<dx-validation-group id="UDX">
  <div class="np-scrollable h-100">
    <dx-data-grid
        class="h-100"
      [dataSource]="model"
      [remoteOperations]="false"
      [allowColumnReordering]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      noDataText="{{ 'keine UDX Felder' | translate }}"
      [showBorders]="true"
      (onRowUpdated)="update($event)"
      (onRowRemoving)="onRowRemoving($event)"
      (onRowRemoved)="delete($event)"
      [customizeColumns]="customizeColumns"
    >
      <dxo-editing
        mode="cell"
        [allowUpdating]="!readOnlyUser('udxDelete')"
        [allowDeleting]="!readOnlyUser('udxDelete')"
        [useIcons]="true"
      >
        <dxo-texts confirmDeleteMessage="" confirmDeleteTitle=""></dxo-texts>
      </dxo-editing>

      <dxo-state-storing
        [enabled]="true"
        type="localStorage"
        storageKey="UdxStateNewUIV2"
      ></dxo-state-storing>

      <dxi-column
        dataField="category"
        caption="{{ 'Gruppe' | translate }}"
        [allowEditing]="true"
        headerCellTemplate="specialCharactersHeaderTemplate"
        cellTemplate="categoryTemplate"
        editCellTemplate="categoryTemplate"
      ></dxi-column>

      <div *dxTemplate="let header of 'specialCharactersHeaderTemplate'" class="d-flex align-items-center gap-1">
        <span>{{ header.column.caption }}</span>
        <i
          class="dx-icon dx-icon-info udx-special-characters-info"
          (mouseenter)="specialCharactersHintTarget = $event.target"
          (mouseleave)="specialCharactersHintTarget = null"
        ></i>
      </div>

      <div *dxTemplate="let data of 'categoryTemplate'" class="d-flex flex-row">
        <div class="np-field w-100">
          <np-inputControl
            [(model)]="product"
            [showLinkButtons]="showLinkButtons"
            [showPlaceLabel]="data?.data?.category?.length > 0"
            [suppressLabel]="true"
            [(selectedElements)]="selectedElements"
            (elementSelected)="templateSelect($event, data.data.order.toString())"
            (onValueChanged)="update($event)"
            field="UDX_CATEGORY"
            [system]="data.data.order.toString()"
            [showDragHandle]="showDragHandle"
            [dragFilter]="dragFilter"
            (excelElementDropped)="excelElementDrop($event)"
          >
            <div slot="content" class="contentSlot">
              <dx-text-box
                [(value)]="data.data.category"
                hint="{{ 'UdxSpecialCharactersHint' | translate }}"
                [showClearButton]="showClearButton('UDX_CATEGORY', data.data.order.toString())"
                [readOnly]="readOnlyForLinkedFields('UDX_CATEGORY', data.data.order.toString()) || readOnlyUser('udxCategory')"
                (onValueChanged)="update($event, 'UDX_CATEGORY', data.data.order.toString())"
              >
                <dx-validator
                  *ngIf="!templateView && product"
                  validationGroup="UDX"
                  (onInitialized)="validationService.startAutomaticValidation($event)"
                >
                  <dxi-validation-rule
                    type="async"
                    [validationCallback]="validationService.validateField('UDX_CATEGORY', data.data.order.toString())"
                  ></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
          </np-inputControl>
        </div>
      </div>

      <dxi-column
        dataField="name"
        caption="{{ 'Name' | translate }}"
        [allowEditing]="true"
        headerCellTemplate="specialCharactersHeaderTemplate"
        cellTemplate="nameTemplate"
        editCellTemplate="nameTemplate"
      ></dxi-column>

      <div *dxTemplate="let data of 'nameTemplate'" class="d-flex flex-row">
        <div class="np-field w-100">
          <np-inputControl
            [(model)]="product"
            [showLinkButtons]="showLinkButtons"
            [showPlaceLabel]="data?.data?.name?.length > 0"
            [suppressLabel]="true"
            [(selectedElements)]="selectedElements"
            (elementSelected)="templateSelect($event, data.data.order.toString())"
            (onValueChanged)="update($event)"
            field="UDX_NAME"
            [system]="data.data.order.toString()"
            [showDragHandle]="showDragHandle"
            [dragFilter]="dragFilter"
            (excelElementDropped)="excelElementDrop($event)"
          >
            <div slot="content" class="contentSlot">
              <dx-text-box
                [(value)]="data.data.name"
                hint="{{ 'UdxSpecialCharactersHint' | translate }}"
                [showClearButton]="showClearButton('UDX_NAME', data.data.order.toString())"
                [readOnly]="readOnlyForLinkedFields('UDX_NAME', data.data.order.toString()) || readOnlyUser('udxName')"
                (onValueChanged)="update($event, 'UDX_NAME', data.data.order.toString())"
              >
                <dx-validator
                  *ngIf="!templateView && product"
                  validationGroup="UDX"
                  (onInitialized)="validationService.startAutomaticValidation($event)"
                >
                  <dxi-validation-rule
                    type="async"
                    [validationCallback]="validationService.validateField('UDX_NAME', data.data.order.toString())"
                  ></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
          </np-inputControl>
        </div>
      </div>

      <dxi-column
        dataField="value"
        caption="{{ 'Wert' | translate }}"
        [allowEditing]="true"
        cellTemplate="valueTemplate"
        editCellTemplate="valueTemplate"
      ></dxi-column>

      <div *dxTemplate="let data of 'valueTemplate'" class="d-flex flex-row">
        <div class="np-field w-100">
          <np-inputControl
            [(model)]="product"
            [showLinkButtons]="showLinkButtons"
            [showPlaceLabel]="data?.data?.value?.length > 0"
            [suppressLabel]="true"
            [(selectedElements)]="selectedElements"
            (elementSelected)="templateSelect($event, data.data.order.toString())"
            (onValueChanged)="update($event)"
            field="UDX_VALUE"
            [system]="data.data.order.toString()"
            [showDragHandle]="showDragHandle"
            [dragFilter]="dragFilter"
            (excelElementDropped)="excelElementDrop($event)"
          >
            <div slot="content" class="contentSlot">
              <dx-text-box
                [(value)]="data.data.value"
                [showClearButton]="showClearButton('UDX_VALUE', data.data.order.toString())"
                [readOnly]="readOnlyForLinkedFields('UDX_VALUE', data.data.order.toString()) || readOnlyUser('udxValue')"
                (onValueChanged)="update($event, 'UDX_VALUE', data.data.order.toString())"
              >
                <dx-validator
                  *ngIf="!templateView && product"
                  validationGroup="UDX"
                  (onInitialized)="validationService.startAutomaticValidation($event)"
                >
                  <dxi-validation-rule
                    type="async"
                    [validationCallback]="validationService.validateField('UDX_VALUE', data.data.order.toString())"
                  ></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
          </np-inputControl>
        </div>
      </div>
    </dx-data-grid>
  </div>
</dx-validation-group>

<dx-tooltip [target]="specialCharactersHintTarget" [visible]="!!specialCharactersHintTarget" position="bottom">
  <div *dxTemplate="let data of 'content'" class="udx-special-characters-hint">
    {{ 'UdxSpecialCharactersHint' | translate }}
  </div>
</dx-tooltip>

 <footer class="np-footer">
    <dx-button
      *ngIf="canView('udxAdd')"
      stylingMode="outlined"
      type="default"
      [disabled]="readOnlyUser('udxAdd')"
      text="{{ 'Neues UDX' | translate }}"
      (onClick)="addUDX()"
    ></dx-button>
  </footer>